import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";

export default function LegalPage({ contentKey }) {
  const [data, setData] = useState({});
  useEffect(() => { api.get(`/content/${contentKey}`).then((r) => setData(r.data?.data || {})); }, [contentKey]);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Seo title={data.title} description={data.title} />
      <p className="text-xs uppercase tracking-luxe text-brand-pink mb-2">Crochet Kerry</p>
      <h1 className="font-serif-display text-4xl sm:text-5xl mb-8" data-testid="legal-title">{data.title}</h1>
      <div className="prose max-w-none">
        {(data.body || "").split("\n\n").map((p, i) => <p key={i} className="text-muted-foreground leading-relaxed mb-4 whitespace-pre-line">{p}</p>)}
      </div>
    </div>
  );
}
